import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../login/login.service';
import { BaseFormGroup } from 'src/app/shared/form-input-components/base-form-group';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['../login/login.component.scss', './reset-password.component.scss']
})
export class ResetPasswordComponent extends BaseFormGroup implements OnInit {
  public isLoading: boolean;
  private token: any;
  private buId: any;
  public passwordReset: boolean;
  public loginLink: string;
  public showError: boolean;
  public showValidationError: boolean;
  private client: any;
  errorMsg: string;

  constructor(private activatedRoute: ActivatedRoute,  private loginService: LoginService) {
    super();
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params.token;
      this.buId = params.buId;
      this.client = params.client;
    });
    this.formDetails = new FormGroup({
      password: new FormControl('', [Validators.required]),
      confirmPassword: new FormControl('', [Validators.required])
    }, {validators: this.passwordConfirming});
  }

  passwordConfirming(c: AbstractControl): any {
    if (c.get('password').value !== c.get('confirmPassword').value) {
        return {passwordMatch: true};
    }
  }

  onSubmit() {
    if (this.formDetails.valid) {
      this.isLoading = true;
      const request = {
        buId: this.buId,
        client: this.client,
        password: this.formDetails.get('password').value,
        token: this.token
      };
      this.loginLink = `/${request.client}/login`;
      this.loginService.updatePassword(request).subscribe((resonse) => {
        this.isLoading = false;
        this.passwordReset = true;
      }, (response) => {
        this.isLoading = false;
        this.errorMsg = response.error.message;
        this.showError = true;
      });
    } else {
      this.markFormGroupDirty(this.formDetails);
      this.showValidationError = true;
    }
  }

  dismissError() {
    this.showError = false;
  }

}
